import { Toast } from "antd-mobile";
const copy = require("copy-to-clipboard");
const QRcode = require("qrcodejs2");

function isMobile() {
    if (
        /gt-p1000|iphone|android|phone|mobile|wap|netfront|java|operamobi|operamini|ucweb|windowsce|symbian|series|webos|sony|blackberry|dopod|nokia|samsung|palmsource|xda|pieplus|meizu|midp|cldc|motorola|foma|docomo|up.browser|up.link|blazer|helio|hosin|huawei|novarra|coolpad|webos|techfaith|palmsource|alcatel|amoi|ktouch|nexian|ericsson|philips|sagem|wellcom|bunjalloo|maui|smartphone|iemobile|spice|bird|zte-|longcos|pantech|gionee|portalmmm|jigbrowser|hiptop|benq|haier|^lct|320x320|240x320|176x220|mqqbrowser/i.test(
            navigator.userAgent.toLowerCase()
        )
    ) {
        return true;
    }
    return false;
}

export type IShareType = "qq" | "weibo" | "qzone" | "baidu" | "weixin";

interface IShareParams {
    title?: string;
    url?: string;
    pic?: string;
    desc?: string | null;
}

interface ICreateUrl extends IShareParams {
    type: IShareType;
}

interface ICore extends ICreateUrl {
    /**
     * 是否是移动端
     */
    ismob?: boolean;

    /**
     * 移动端复制链接后的提示
     */
    mobMsg?: string;

    /**
     * pc端 微信分享生成二维码的容器
     */
    codeContainer?: HTMLElement;
}

function createBase(params: IShareParams, picKey = "pics", haved = true) {
    const { title = "", url = "", desc, pic } = params;
    let shareUrl = "";
    shareUrl += `?title=${encodeURIComponent(title)}`;
    shareUrl += `&url=${encodeURIComponent(url)}`;
    if (haved && desc) shareUrl += `&desc=${encodeURIComponent(desc)}`;
    if (pic) shareUrl += `&${picKey}=${encodeURIComponent(pic)}`;
    return shareUrl;
}

class ShareOpen {
    static qq(params: IShareParams) {
        let shareUrl = "https://connect.qq.com/widget/shareqq/index.html";
        shareUrl += createBase(params, "pics");
        return shareUrl;
    }

    static qzone(params: IShareParams) {
        let shareUrl = "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey";
        shareUrl += createBase(params, "pics");
        const { title = "", desc } = params;
        shareUrl += `&summary=${encodeURIComponent(desc || title)}`;
        return shareUrl;
    }

    static weibo(params: IShareParams) {
        let shareUrl = "https://service.weibo.com/share/share.php";
        shareUrl += createBase(params, "pic", false);
        shareUrl += `&content=utf-8`;
        return shareUrl;
    }

    static baidu(params: IShareParams) {
        let shareUrl = "http://tieba.baidu.com/f/commit/share/openShareApi";
        shareUrl += createBase(params, "pic", false);
        return shareUrl;
    }
}

function openWindow(map: ICreateUrl) {
    const mate = document.querySelector('meta[name="description"]');
    const defaultDesc = mate ? mate.getAttribute("content") : "";
    const { type, title = document.title, url = window.location.href, pic, desc = defaultDesc } = map;
    const openUrl = ShareOpen[type]({ title, url, pic, desc });
    window.open(openUrl, "_blank", "location=yes,left=200,top=100,width=750,height=500,resizable=yes");
}

function renderCode(url: string) {
    const box = document.createElement("div");
    const qr = new QRcode(box, {
        text: url,
        colorDark: "#000000",
        colorLight: "#FFFFFF",
        width: 200,
        height: 200,
        correctLevel: Number(QRcode.CorrectLevel.L)
    });
    console.log(qr);
    const image: any = box.children[1];
    image.style.width = "100%";
    return image;
}

export default function ThirdShareCore(param: ICore) {
    const { ismob, mobMsg = "分享链接已复制，快去分享给你的好友吧", codeContainer, ...other } = param;
    const { type, url = "" } = other;

    if (isMobile() || ismob) {
        // 移动端分情况  微博 空间 百度可以直接跳转；
        if (type === "weibo" || type === "qzone" || type === "baidu") {
            openWindow(other);
            return;
        }
        copy(url);
        Toast.show(mobMsg, 3, true);
    } else {
        if (type !== "weixin") {
            // pc 端直接跳转
            openWindow(other);
            return;
        }
        if (codeContainer) {
            try {
                codeContainer.appendChild(renderCode(url));
            } catch (e) {}
        }
    }
}
